export default __webpack_public_path__ + "static/media/handshake.e90866a6.png";